<div class="connect-claude">
  @switch (state) {
    @case ('consent') {
      <h1 class="h4" i18n="@@connectClaude.connectClaude.consentTitle">Allow Claude to access FBO?</h1>
      <p i18n="@@connectClaude.connectClaude.consentMessage">Claude will be able to read your FBO data, such as your Workflow Hub tasks. It sees only what you can see in FBO, and it can't make changes.</p>
      @if (signedInAs) {
        <p class="connect-claude__account" i18n="@@connectClaude.connectClaude.signedInAs">Signed in as {{ signedInAs }}</p>
      }
      <div class="connect-claude__actions">
        <button class="btn btn-default" type="button" (click)="cancel()" i18n="@@connectClaude.connectClaude.cancel">
          Cancel
        </button>
        <button class="btn btn-primary" type="button" (click)="allow()" i18n="@@connectClaude.connectClaude.allow">
          Allow
        </button>
      </div>
    }
    @case ('connecting') {
      <p role="status" aria-live="polite" i18n="@@connectClaude.connectClaude.connecting">Connecting Claude to FBO…</p>
    }
    @case ('cancelling') {
      <p role="status" aria-live="polite" i18n="@@connectClaude.connectClaude.cancelling">Returning to Claude…</p>
    }
    @case ('failed') {
      <h1 class="h4" i18n="@@connectClaude.connectClaude.failedTitle">We couldn't connect Claude to FBO</h1>
      <p i18n="@@connectClaude.connectClaude.failedMessage">Go back to Claude and select Connect again.</p>
    }
  }
</div>
